import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ROOT_URL } from '../../api/ApiConfig';

/** Groups the current user can access (for select dropdowns). */
export const listAccessibleGroupsAPI = createAsyncThunk(
  'group/accessible',
  async (_, { getState, rejectWithValue }) => {
    const { loginToken } = getState();
    const authToken = loginToken?.response?.token;
    try {
      const response = await fetch(`${ROOT_URL}/group/accessible`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
      });
      const result = await response.json();
      return result;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  },
);

/** Full business group list (admin / team management). Prefer listAccessibleGroupsAPI for dropdowns. */
export const listGroupAPI = createAsyncThunk('group/list', async (_, { getState, rejectWithValue }) => {
  const { loginToken } = getState();
  const authToken = loginToken?.response?.token;
  try {
    const response = await fetch(
      `${ROOT_URL}/group/list`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
      },
    );
    const result = await response.json();
    return result;
  } catch (error) {
    return rejectWithValue(error.response);
  }
});

const initialState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  isCompleted: false,
  response: [],
  error: null,
};

const listGroup = createSlice(
  {
    name: 'addGroup',
    initialState,
    reducers: {},
    extraReducers: {
      [listGroupAPI.pending]: (state) => ({
        ...state,
        isLoading: true,
      }),
      [listGroupAPI.fulfilled]: (state, action) => ({
        ...state,
        isLoading: false,
        isSuccess: true,
        isError: false,
        response: action.payload,
      }),
      [listGroupAPI.rejected]: (state, action) => ({
        ...state,
        isLoading: false,
        isSuccess: false,
        isError: true,
        error: action.payload,
      }),
      [listAccessibleGroupsAPI.pending]: (state) => ({
        ...state,
        isLoading: true,
      }),
      [listAccessibleGroupsAPI.fulfilled]: (state, action) => ({
        ...state,
        isLoading: false,
        isSuccess: true,
        isError: false,
        response: action.payload,
      }),
      [listAccessibleGroupsAPI.rejected]: (state, action) => ({
        ...state,
        isLoading: false,
        isSuccess: false,
        isError: true,
        error: action.payload,
      }),
    },
  },
);

export default listGroup;
